/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function (n, x, s, c) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
    num = this.toFixed(Math.max(0, ~~n));

  return (c ? num.replace(".", c) : num).replace(
    new RegExp(re, "g"),
    "$&" + (s || ",")
  );
};

/**
 * String.prototype.numeroToNumber(n)
 *
 * @param integer n: length of decimal
 */
String.prototype.numeroToNumber = function (n) {
  var num = this.replace(/[^0-9\.,\-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  if (n) num = Number(num).toFixed(n);
  return Number(num);
};

Number.prototype.numberToNumero = function (decimais = 2) {
  return this.format(decimais, 3, ".", ",");
};

String.prototype.rsPrefix = function () {
  return "R$ " + this;
};

Array.prototype.max = function () {
  return Math.max.apply(null, this);
};

Array.prototype.min = function () {
  return Math.min.apply(null, this);
};

String.prototype.slugify = function () {
  return window.slugify(this);
};

window.makeid = () => {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

window.summernoteSendFile = (file, editor) => {
  var imgId = makeid();

  $(editor).summernote(
    "insertImage",
    "images/loading-spinner.gif",
    function ($image) {
      $image.attr("id", imgId);
    }
  );

  data = new FormData();
  data.append("files[]", file);
  data.append("summernoteFile", 1);
  $.ajax({
    data: data,
    type: "POST",
    url: "admin/summernote/upload",
    cache: false,
    contentType: false,
    processData: false,
    success: function (response) {
      var original = $(editor.summernote("code"));

      response.files.forEach(function (f) {
        original
          .find("#" + imgId)
          .attr("src", f.url)
          .removeAttr("id");
      });

      editor.summernote("code", original);
    },
    error: function (err) {
      if (err.status == 403) {
        $.gritter.add({
          title: "Acesso negado",
          text: err.responseText,
          time: 10000,
          class_name: "erro",
        });
      } else {
        alert("Erro ao enviar imagem. Por favor, tente novamente.");
      }

      console.error(err);

      var original = $(editor.summernote("code"));

      original.find("#" + imgId).remove();

      editor.summernote("code", original);
    },
  });
};

window.SUMMERNOTE_DEFAULT_CONFIGS = {
  height: 300,
  lang: "pt-BR",
  toolbar: [
    ["fontsize", ["fontsize"]],
    ["style", ["bold", "italic", "underline", "strikethrough", "clear"]],
    ["alignment", ["ul", "ol", "paragraph"]],
    ["insert", ["link", "picture", "hr", "table"]],
    ["view", ["fullscreen", "codeview"]],
    ["help", ["help"]],
  ],
  callbacks: {
    onPaste: function (e) {
      var thisNote = $(this);
      var updatePastedText = function (someNote) {
        var original = someNote.summernote("code");
        var cleaned = cleanPastedHTML(original); //this is where to call whatever clean function you want. I have mine in a different file, called CleanPastedHTML.
        someNote.summernote("code", cleaned); //this sets the displayed content editor to the cleaned pasted code.
      };
      setTimeout(function () {
        //this kinda sucks, but if you don't do a setTimeout,
        //the function is called before the text is really pasted.
        updatePastedText(thisNote);
      }, 10);
    },
    onImageUpload: function (files) {
      summernoteSendFile(files[0], $(this));
    },
    onInit: function () {
      //Quando estiver dentro de um modal, religar os botões
      var thisNote = $(this);

      if (thisNote.closest(".modal").length > 0) {
        thisNote.next().find(".dropdown-toggle").dropdown();
      }
    },
  },
};

$(document).ready(function () {
  $.gritter.options.position = "bottom-right";

  if ($("#mensagem .alert").length > 0) {
    var $mensagem = $("#mensagem .alert").clone();
    $mensagem.find("button").remove();
    $mensagem.find("li").wrapInner("<p></p>");

    $.gritter.add({
      title:
        "<b>" +
        ($("#mensagem .alert").hasClass("alert-success")
          ? "Sucesso"
          : "Oops!") +
        "</b>",
      text: $mensagem.html(),
      time: $("#mensagem .alert").hasClass("alert-success") ? 5000 : 10000,
      class_name: $("#mensagem .alert").hasClass("alert-success")
        ? "sucesso"
        : "erro",
    });
  }

  $("body").click(function (event) {
    var container = $(".bootstrap-datetimepicker-widget");
    container.parent().datetimepicker("hide");

    //fechar popover do title quando clicar fora

    if (
      $(".popover.show").length > 0 &&
      (!$(event.target).attr("aria-describedby") ||
        $(event.target).attr("aria-describedby").indexOf("popover") === -1)
    ) {
      if (!$(event.target).closest(".popover.show").length) {
        $("[aria-describedby^=popover]").each(function () {
          $(this).removeAttr("aria-describedby").popover("dispose");
        });
      }
    }
  });

  $("body").on("click", "i[title]", function () {
    if ($(this).attr("aria-describedby")) {
      $(this).removeAttr("aria-describedby").popover("dispose");
    } else {
      $(this)
        .popover({
          template:
            '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3></div>',
        })
        .popover("show");
    }
  });
});

window.addYoutubeEventListener = (function () {
  var callbacks = [];
  var iframeId = 0;
  var subscribed = [];

  return function (iframe, callback) {
    // init message listener that will receive messages from youtube iframes
    if (iframeId === 0) {
      window.addEventListener(
        "message",
        function (e) {
          if (e.origin !== "https://www.youtube.com" || e.data === undefined)
            return;
          try {
            var data = JSON.parse(e.data);
            subscribed[data.id] = true;
            if (data.event !== "onStateChange") return;

            var callback = callbacks[data.id];
            callback(data);
          } catch (e) {}
        },
        true
      );
    }

    // store callback
    iframeId++;
    callbacks[iframeId] = callback;
    subscribed[iframeId] = false;
    var currentFrameId = iframeId;

    //console.log("adding event listener to iframe id " + iframeId);

    // sendMessage to frame to start receiving messages
    iframe.addEventListener(
      "load",
      function () {
        var tries = 0;
        var checkSubscribed = function () {
          if (subscribed[currentFrameId]) {
            //console.log("subscribed succesfully " + currentFrameId)
          } else {
            tries++;
            //console.log("Try again " + currentFrameId + " (" + tries + ")");
            if (tries < 100) {
              doSubscribe();
            } else {
              console.log("Unable to subscribe" + currentFrameId);
            }
          }
        };
        var doSubscribe = function () {
          var message = JSON.stringify({
            event: "listening",
            id: currentFrameId,
            channel: "widget",
          });
          iframe.contentWindow.postMessage(message, "https://www.youtube.com");

          message = JSON.stringify({
            event: "command",
            func: "addEventListener",
            args: ["onStateChange"],
            id: currentFrameId,
            channel: "widget",
          });
          iframe.contentWindow.postMessage(message, "https://www.youtube.com");
          setTimeout(checkSubscribed, 100);
        };
        doSubscribe();
      },
      true
    );
  };
})();
